import { createContext, useContext, useState, useCallback } from 'react';
import './Confirm.css';

const ConfirmContext = createContext();

export const ConfirmProvider = ({ children }) => {
  const [state, setState] = useState(null);

  const confirm = useCallback((message, options = {}) =>
    new Promise(resolve => {
      setState({
        message,
        title:       options.title       || 'Confirm',
        confirmText: options.confirmText || 'Confirm',
        cancelText:  options.cancelText  || 'Cancel',
        type:        options.type        || 'danger',
        resolve,
      });
    }), []);

  const handle = (result) => {
    state?.resolve(result);
    setState(null);
  };

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}
      {state && (
        <div className="confirm-overlay" onClick={() => handle(false)}>
          <div className="confirm-box" onClick={e => e.stopPropagation()}>
            <div className={`confirm-icon confirm-${state.type}`}>
              {state.type === 'danger' ? '🗑️' : state.type === 'warning' ? '⚠️' : 'ℹ️'}
            </div>
            <h3 className="confirm-title">{state.title}</h3>
            <p className="confirm-msg">{state.message}</p>
            <div className="confirm-actions">
              <button className="btn btn-gray" onClick={() => handle(false)}>{state.cancelText}</button>
              <button className={`btn ${state.type === 'danger' ? 'btn-red' : 'btn-blue'}`}
                onClick={() => handle(true)}>{state.confirmText}</button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
};

export const useConfirm = () => useContext(ConfirmContext);
